/**
 * TabBar — Standard tab navigation (underline style).
 * Matches Tax Management design: underline active, no background change.
 */
import React from 'react';

interface Tab {
  key: string;
  label: string;
  count?: number;
}

interface TabBarProps {
  tabs: Tab[] | string[];
  active: string;
  onChange: (key: string) => void;
}

export default function TabBar({ tabs, active, onChange }: TabBarProps) {
  const normalized: Tab[] = tabs.map(t =>
    typeof t === 'string' ? { key: t.toLowerCase().replace(/\s+/g, '_'), label: t } : t
  );

  return (
    <div style={{ display: 'flex', gap: 0, borderBottom: '2px solid var(--border-subtle)', marginBottom: 24 }}>
      {normalized.map(t => (
        <button
          key={t.key}
          onClick={() => onChange(t.key)}
          style={{
            padding: '10px 20px', fontSize: 13,
            fontWeight: active === t.key ? 700 : 500,
            color: active === t.key ? 'var(--navy-900)' : 'var(--text-secondary)',
            background: 'none', border: 'none', cursor: 'pointer',
            borderBottom: active === t.key ? '2px solid var(--navy-900)' : '2px solid transparent',
            marginBottom: -2, transition: 'all 0.15s',
            display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          {t.label}
          {t.count != null && t.count > 0 && (
            <span style={{
              fontSize: 10, fontWeight: 600, background: 'var(--accent-subtle)',
              color: 'var(--navy-900)', padding: '1px 6px', borderRadius: 8, minWidth: 18, textAlign: 'center',
            }}>
              {t.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
